module.exports = __webpack_public_path__ + "static/media/VidgoTablet2.1f48fc84.jpg";